import { render } from "./Stationery.vue?vue&type=template&id=88938c12&scoped=true"
import script from "./Stationery.vue?vue&type=script&lang=js"
export * from "./Stationery.vue?vue&type=script&lang=js"

import "./Stationery.vue?vue&type=style&index=0&id=88938c12&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88938c12"]])

export default __exports__